import React, { MouseEvent, forwardRef } from "react";
import { useTheme } from "@mui/material";

import { AddCircleOutlineIcon, Button, Badge } from "./styled";
import { ButtonProps } from "@mui/material";

export type BaseFilterButtonProps = {
  label: string;
  appliedCount?: number;
  onClear?: () => void;
  canRemoveWhenEmpty?: boolean;
} & ButtonProps;

export const BaseFilterButton = forwardRef<HTMLButtonElement, BaseFilterButtonProps>(
  (
    {
      label,
      appliedCount,
      onClear,
      canRemoveWhenEmpty,
      ...rest
    },
    ref
  ) => {
    const hasFiltersApplied = appliedCount && appliedCount > 0;
    const theme = useTheme();

    const handleClear = (e: MouseEvent) => {
      if ((!canRemoveWhenEmpty && !hasFiltersApplied) || !onClear) return;
      e.stopPropagation();
      onClear();
    };

    return (
      <Button
        {...rest}
        ref={ref}
        size="small"
        disableRipple
        hasFiltersApplied={!!hasFiltersApplied}
        endIcon={
          appliedCount && (
            <Badge
              badgeContent={appliedCount}
              data-testid="applied-filter-count"
            />
          )
        }
        startIcon={
          <AddCircleOutlineIcon
            fontSize="small"
            onClick={handleClear}
            data-testid="clear-filter"
            canRemove={!!hasFiltersApplied || canRemoveWhenEmpty}
            sx={{
              width: theme.typography.body1.fontSize,
              height: theme.typography.body1.fontSize,
            }}
          />
        }
      >
        {label}
      </Button>
    );
  }
);

BaseFilterButton.displayName = "BaseFilterButton";
